module.exports = __webpack_public_path__ + "static/media/93ConnectIcon_glow.0136ed2f.png";